import RoadLocatorSegment from "./roadLocatorSegment";

export default class RoadLocatorSegmentsData {
  public roadLocatorSegments: RoadLocatorSegment[] = [];
  public roadLocatorSegmentsDataItems: RoadLocatorSegment[] = [];
}
